import React, { useState } from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function AiPromptsButton() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const prompts = [
    { id: "forecast-3m", label: "Sales Forecast (3 months)" },
    { id: "find-supplier", label: "Look for Supplier" },
  ];
  const nonCustomPrompts = [
    // 📊 Sales Analytics
    {
      label: "Today's Sales",
      value: `What are the total sales for ${new Date().toLocaleDateString()}?`
    },
    {
      label: "Best-Selling Product (This Week)",
      value: `Which product sold the most this week? Today is ${new Date().toLocaleDateString()}`
    },
    {
      label: "Average Daily Sales (This Month)",
      value: `What is the average sales per day this month? Today is ${new Date().toLocaleDateString()}`
    },
    {
      label: "Compare Weekly Sales",
      value: `How does this week’s sales compare to last week? Today is ${new Date().toLocaleDateString()}`
    },
  
    // 📦 Inventory & Stock
    {
      label: "Low Stock Items",
      value: "Which items are running low on stock?"
    },
    {
      label: "Out of Stock",
      value: "Show me products that are out of stock."
    },
    {
      label: "No Sales in 30 Days",
      value: `Which items haven’t sold in the last 30 days? Today is ${new Date().toLocaleDateString()}`
    },
    {
      label: "Fast-Selling Products",
      value: "What products usually sell out the fastest?"
    },
  
    // 💰 Profitability & Cost
    {
      label: "Most Profitable Products",
      value: "Which products bring in the most profit?"
    },
    {
      label: "Revenue vs Cost (Last Month)",
      value: `How did revenue compare to costs last month? Today is ${new Date().toLocaleDateString()}`
    },
    {
      label: "Highest Profit Margins",
      value: "Which products have the highest profit margins?"
    }
  ];
  

  const handlePromptClick = (id) => {
    setShowModal(false);
    navigate(`/prompts/${id}`);
  };

  return (
    <div>
      <div className="forecast-card">
        <div
          className="forecast-bg"
          onClick={() => setShowModal(true)}
          style={{
            backgroundImage: `url("/ai_prompt.png")`,
            cursor: "pointer",
          }}
        ></div>
        {/* <h2>A.I.</h2>
        <button onClick={() => setShowModal(true)}>AI Prompts</button> */}

        {showModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "40px",
                borderRadius: "8px",
                boxShadow: "0px 0px 30.7px 0px #00000066",

              }}
            >
              {/* <h2 className="mb-0">Select AI Prompt</h2>
              <hr className="my-2" />
              <ul style={{ listStyle: "none", padding: 0 }}>
                {prompts.map((p) => (
                  <li key={p.id} style={{ marginBottom: "10px" }}>
                    <button
                      className="btn btn-primary"
                      onClick={() => handlePromptClick(p.id)}
                    >
                      {p.label}
                    </button>
                  </li>
                ))}
              </ul>
              <hr className="my-2" />
              <button
                className="btn btn-danger"
                onClick={() => setShowModal(false)}
              >
                Close
              </button> */}
              <Container fluid>
                <Row>
                  <Col>
                    <div className="ai_prompt_header">
                      <Container fluid>
                        <Row>
                          <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                            <img src="/ai_prompt2.png" alt="" />
                          </Col>
                          <Col xl={8} lg={8} md={8} sm={8} xs={8}>
                            <div className="ai_text">
                              <h2 className="mb-0">AI Prompt</h2>
                              <p>
                                Ask AI anything about your business from recent
                                sales performance to current inventory levels or
                                stock alerts and get smart, auto-generated
                                options tailored to your data.
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                    <div className="mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          const formData = new FormData(
                            e.target instanceof HTMLFormElement
                              ? e.target
                              : null
                          );
                          const prompt = formData.get("prompt"); // Get value by name
                          window.location.href = `${
                            window.location.protocol
                          }//${window.location.hostname}${
                            window.location.port
                              ? ":" + window.location.port
                              : ""
                          }/custom-prompt?prompt=${prompt}`;
                        }}
                      >
                        <Form.Control
                          style={{
                            borderRadius: 70,
                            padding: "10px 20px",
                            fontSize: "1.5em",
                          }}
                          placeholder="Ask anything"
                          name="prompt"
                        />
                        <button type="submit" className="d-none">
                          submit
                        </button>
                      </Form>
                    </div>
                    <div className="ai_btn" style={{maxWidth:900}}>
                      {prompts.map((p) => (
                        <button
                          key={p.id}
                          onClick={() => handlePromptClick(p.id)}
                          className="mb-2"
                        >
                          {p.label}
                        </button>
                      ))}
                      {nonCustomPrompts.map((p,i) => (
                        <button
                          key={i}
                          onClick={() =>  window.location.href = `${
                            window.location.protocol
                          }//${window.location.hostname}${
                            window.location.port
                              ? ":" + window.location.port
                              : ""
                          }/custom-prompt?prompt=${p.value}`}
                          className="mb-2"
                        >
                          {p.label}
                        </button>
                      ))}
                      
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
